<template>
    <div class="mine">
		<div class="mine_head">
			
		</div>
		<div class="min_user">
			<div class="mine_img">
				<img :src="userInfo.avatar">
			</div>
			<div class="min_user_name">
				<span>{{userInfo.name}}</span>
			</div>
			<div class="mun_bottonm">
				<div class="mb_left">
					<span>{{userInfo.telphone}}</span>
				</div>
				<div class="mb_right" @click="toEdit">
					<van-icon name="edit" size="28" color="#4E89FF" />
					<span>编辑</span>
				</div>
			</div>
		</div>
		<div class="min_add" @click="toUserList" v-if="userInfo.studio_role=='host'">
			<div class="minadd_left">
				<div class="ml_icon">
					<van-icon name="user-o" size="36" color="#4E89FF" />
				</div>
				<div class="ml_name">
					<span>用户管理</span>
				</div>
			</div>
			<div class="minadd_right">
				<van-icon name="arrow" size="20" color="#4E89FF" />
			</div>
		</div>
		<div class="min_add" @click="toInternalWorkbench" v-if="isIotmaxUser">
			<div class="minadd_left">
				<div class="ml_icon">
					<van-icon name="apps-o" size="36" color="#4E89FF" />
				</div>
				<div class="ml_name">
					<span>内部工作台</span>
				</div>
			</div>
			<div class="minadd_right">
				<van-icon name="arrow" size="20" color="#4E89FF" />
			</div>
		</div>

		<!-- 仓库工作台暂时注释
		<div class="warehouse_dashboard" v-if="isIotmaxUser">
			<div class="dashboard_top">
				<div>
					<div class="dashboard_title">仓库工作台</div>
					<div class="dashboard_subtitle">{{currentWarehouseName || '未选择仓库'}}</div>
				</div>
				<div class="dashboard_manage" @click="toWarehouseManage">
					<van-icon name="setting-o" size="18" />
					<span>管理</span>
				</div>
			</div>
			<div class="dashboard_stats">
				<div class="dashboard_stat" @click="toProductList">
					<span class="stat_num">{{productTotal}}</span>
					<span class="stat_label">产品</span>
				</div>
				<div class="dashboard_stat" @click="toMaterialList" v-if="userInfo.stock_user_view_power != 1">
					<span class="stat_num green">{{materialTotal}}</span>
					<span class="stat_label">物料</span>
				</div>
				<div class="dashboard_stat" @click="toShipmentRecord">
					<span class="stat_num red">{{pendingShipmentCount}}</span>
					<span class="stat_label">待发货</span>
				</div>
			</div>
			<div class="dashboard_actions">
				<div class="dashboard_action primary" @click="openShipment('product')">
					<van-icon name="logistics" size="18" />
					<span>产品发货</span>
				</div>
				<div class="dashboard_action success" @click="openShipment('material')" v-if="userInfo.stock_user_view_power != 1">
					<van-icon name="send-gift-o" size="18" />
					<span>物料发货</span>
				</div>
			</div>
		</div>
		-->

		<!-- 产品预览区 -->
		<div class="preview_section" v-if="isIotmaxUser">
			<div class="section_header">
				<div class="section_title_left">
					<van-icon name="shop-o" size="20" color="#2196F3" />
					<span class="section_title_text">产品</span>
				</div>
				<div class="section_more" @click="toProductList">
					<span>更多</span>
					<van-icon name="arrow" size="16" color="#999" />
				</div>
			</div>
			<!-- 悬浮发货按钮 -->
			<div class="section_float_btn product_float" @click.stop="openShipment('product')">
				<van-icon name="logistics" size="18" color="#fff" />
				<span>发货</span>
			</div>
			<div class="preview_cards" v-if="productList.length > 0">
				<div class="preview_card" v-for="item in productList" :key="item.id" @click="toProductDetail(item)">
					<div class="pc_img">
						<img :src="getFirstImg(item.imgs)" alt="" @error="handleImgError($event)">
					</div>
					<div class="pc_info">
						<div class="pc_name">{{item.name}}</div>
						<div class="pc_code">{{item.code}}</div>
						<div class="pc_stock">
							<span class="stock_total">总量: <b :class="{low: item.stock_num < 10}">{{item.stock_num}}</b></span>
						</div>
						<div class="pc_warehouse" v-if="item.stock_num_info && item.stock_num_info.length">
							<span class="wh_tag" v-for="(wh, idx) in item.stock_num_info" :key="idx">
								{{wh.stock_name}} <b :style="{color: wh.StockNum > 0 ? '#67c23a' : '#c0c4cc'}">{{wh.StockNum}}</b>
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="preview_empty" v-else>
				<span>暂无产品数据</span>
			</div>
		</div>

		<!-- 物料预览区 -->
		<div class="preview_section" v-if="isIotmaxUser && userInfo.stock_user_view_power != 1">
			<div class="section_header">
				<div class="section_title_left">
					<van-icon name="apps-o" size="20" color="#4CAF50" />
					<span class="section_title_text">物料</span>
				</div>
				<div class="section_more" @click="toMaterialList">
					<span>更多</span>
					<van-icon name="arrow" size="16" color="#999" />
				</div>
			</div>
			<!-- 悬浮发货按钮 -->
			<div class="section_float_btn material_float" @click.stop="openShipment('material')">
				<van-icon name="logistics" size="18" color="#fff" />
				<span>发货</span>
			</div>
			<div class="preview_cards" v-if="materialList.length > 0">
				<div class="preview_card" v-for="item in materialList" :key="item.id" @click="toMaterialDetail(item)">
					<div class="pc_img">
						<img :src="getFirstImg(item.imgs)" alt="" @error="handleImgError($event)">
					</div>
					<div class="pc_info">
						<div class="pc_name">{{item.name}}</div>
						<div class="pc_code">{{item.code}}</div>
						<div class="pc_stock">
							<span class="stock_total">总量: <b :class="{low: item.stock_num < 10}">{{item.stock_num}}</b></span>
						</div>
						<div class="pc_warehouse" v-if="item.stock_num_info && item.stock_num_info.length">
							<span class="wh_tag" v-for="(wh, idx) in item.stock_num_info" :key="idx">
								{{wh.stock_name}} <b :style="{color: wh.StockNum > 0 ? '#67c23a' : '#c0c4cc'}">{{wh.StockNum}}</b>
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="preview_empty" v-else>
				<span>暂无物料数据</span>
			</div>
		</div>

		<!-- 发货预览区 -->
		<div class="preview_section" v-if="isIotmaxUser">
			<div class="section_header">
				<div class="section_title_left">
					<van-icon name="logistics" size="20" color="#F44336" />
					<span class="section_title_text">发货</span>
				</div>
				<div class="section_more" @click="toShipmentRecord">
					<span>查看更多</span>
					<van-icon name="arrow" size="16" color="#999" />
				</div>
			</div>
			<!-- 仓库切换 -->
			<div class="mine_wh_row" v-if="warehouseList.length > 1">
				<span class="mine_wh_btn" v-for="wh in warehouseList" :key="wh.stock_code"
					:class="{ active: currentStockCode === String(wh.stock_code) }"
					@click="switchWarehouse(wh)">
					{{wh.stock_name}}
				</span>
			</div>
			<div class="shipment_preview_list" v-if="shipmentList.length > 0">
				<div class="shipment_preview_item" v-for="item in shipmentList" :key="item.id" @click="toShipmentDetail(item)">
					<div class="sp_header">
						<van-tag :type="getShipmentTypeColor(item.shipment_type)" size="medium">
							{{getShipmentTypeText(item.shipment_type)}}
						</van-tag>
						<span class="sp_time">{{formatTime(item.create_time)}}</span>
					</div>
					<div class="sp_body">
						<span class="sp_name">{{item.intro || item.record_name || '-'}}</span>
						<span class="sp_num">{{item.shipment_num || 0}}件</span>
					</div>
					<div class="sp_footer">
						<span class="sp_sale">销售: {{item.sale_user_name || '-'}}</span>
						<span class="sp_status" :class="'step' + getShipmentStep(item)">{{getStepText(item)}}</span>
					</div>
				</div>
			</div>
			<div class="preview_empty" v-else>
				<span>暂无发货记录</span>
			</div>
		</div>

		<!-- 发货弹窗 -->
		<shipment-dialog
			v-model="showShipmentDialog"
			:shipment-type="shipmentType"
			:preselected-items="preselectedShipmentItems"
			:user-info="userInfo"
			@success="onShipmentSuccess"
		/>

		<button class="about_us" type="button" @click="toOfficialWebsite">
			<span class="about_left">
				<span class="about_icon">
					<van-icon name="info-o" size="28" color="#4E89FF" />
				</span>
				<span>关于我们</span>
			</span>
			<span class="about_arrow">
				<van-icon name="arrow" size="20" color="#4E89FF" />
			</span>
		</button>


		<footer-main active="/mine"></footer-main>
    </div>
</template>

<script>
import studio_api from '@/api/teaching_studio_teaching_studio_api.js'
import footerMain from '@/components/footer.vue'
import ShipmentDialog from '@/components/ShipmentDialog.vue'
import {
	formatIotmaxTimestamp,
	getIotmaxShipmentStep,
	getIotmaxShipmentStepText,
	parseIotmaxImageList
} from '@/utils/iotmaxStock.js'
export default {
	name: 'mine',
	data(){
		return{
			userInfo:{},
			isSuper:false,
			productList: [],
			materialList: [],
			shipmentList: [],
			warehouseList: [],
			currentStockCode: '',
			productTotal: 0,
			materialTotal: 0,
			pendingShipmentCount: 0,
			showShipmentDialog: false,
			shipmentType: 'product',
			preselectedShipmentItems: []
		}
	},
	components: {
		footerMain,
		ShipmentDialog
	},
	computed: {
		isIotmaxUser() {
			return this.isSuper || this.userInfo.is_iotmax == 1
		},
		currentWarehouseName() {
			const current = this.warehouseList.find(item => String(item.stock_code) === this.currentStockCode)
			return current ? current.stock_name : ''
		}
	},
	mounted(){
		this.isSuper = this.$root.isSuperRoot
		document.title="我的"
		this.init();
	},
	methods:{
		async init() {
			await this.getUserInfo();
			this.fetchPreviewData();
		},

		//获取当前登录的用户
		async getUserInfo() {
			let app_id = this.$root.app_id;
			let data = await studio_api.Teaching_studio_apiMemberLogin_userGet({ app_id });
			if (data.errcode == 0) {
				this.userInfo = data.other;
			}
		},

		// 获取预览数据
		async fetchPreviewData() {
			this.fetchProducts();
			this.fetchMaterials();
			this.fetchShipments();
			this.loadWarehouseList();
		},

		// 获取1个产品
		async fetchProducts() {
			try {
				let res = await studio_api.Teaching_studio_apiIotmaxProductListGet({
					app_id: this.$root.app_id,
					is_iotmax: 1,
					page: 1,
					each_page: this.userInfo.stock_user_view_power == 1 ? 2 : 1
				})
				if (res.errcode == 0 && res.other && res.other.list) {
					this.productList = res.other.list
					this.productTotal = res.other.count || res.other.list.length
				}
			} catch(e) {}
		},

		// 获取1个物料
		async fetchMaterials() {
			if (this.userInfo.stock_user_view_power == 1) return
			try {
				let res = await studio_api.Teaching_studio_apiIotmaxMaterialListGet({
					app_id: this.$root.app_id,
					page: 1,
					each_page: 1
				})
				if (res.errcode == 0 && res.other && res.other.list) {
					this.materialList = res.other.list
					this.materialTotal = res.other.count || res.other.list.length
				}
			} catch(e) {}
		},

		// 获取1条发货记录
		async fetchShipments() {
			try {
				let data = await studio_api.Teaching_studio_apiIotmaxShipmentListGet({
					app_id: this.$root.app_id,
					page: 1,
					each_page: 10
				})
				if (data.errcode == 0) {
					const list = (data.other && data.other.list) ? data.other.list : []
					this.shipmentList = list.slice(0, 1)
					this.pendingShipmentCount = list.filter(item => this.getShipmentStep(item) < 5).length
				}
			} catch(e) {}
		},

		// 加载仓库列表
		async loadWarehouseList() {
			try {
				let res = await studio_api.Teaching_studio_apiIotmaxStock_listGet({ app_id: this.$root.app_id })
				if (res && res.errcode === 0 && res.other) {
					let list = Array.isArray(res.other) ? res.other : []
					this.warehouseList = list
					let currentWh = list.find(item => item.is_login === 1 || item.is_login === '1')
					if (currentWh) {
						this.currentStockCode = String(currentWh.stock_code)
					} else if (list.length > 0) {
						this.currentStockCode = String(list[0].stock_code)
					}
					this.fetchShipments()
				}
			} catch(e) {
				console.error('获取仓库列表失败', e)
			}
		},

		// 切换仓库
		async switchWarehouse(wh) {
			const value = String(wh.stock_code)
			if (this.currentStockCode === value) return
			try {
				let res = await studio_api.Teaching_studio_apiIotmaxStock_loginPut({
					app_id: this.$root.app_id,
					stock_code: value
				})
				if (res && res.errcode === 0) {
					this.currentStockCode = value
					this.fetchShipments()
				} else {
					this.$toast(res.errmsg || '切换仓库失败')
				}
			} catch(e) {
				console.error('切换仓库失败', e)
				this.$toast('切换仓库失败')
			}
		},

		getFirstImg(imgs) {
			return parseIotmaxImageList(imgs)[0] || '/static/imgs/no_img.png'
		},

		handleImgError(e) {
			e.target.src = '/static/imgs/no_img.png'
		},

		formatTime(ts) {
			return formatIotmaxTimestamp(ts).slice(5)
		},

		getShipmentTypeColor(type) {
			const map = { product: 'primary', material: 'success', other: 'default' }
			return map[type] || 'default'
		},

		getShipmentTypeText(type) {
			const map = { product: '产品', material: '物料', other: '其他' }
			return map[type] || type || '-'
		},

		getShipmentStep(item) {
			return getIotmaxShipmentStep(item)
		},

		getStepText(item) {
			return getIotmaxShipmentStepText(item)
		},

		toEdit(){
			this.$router.push("/edituser")
		},
		toUserList(){
			this.$router.push("/userlist")
		},
		toAfterSalesMobile(){
			this.$router.push("/after-sales/mobile")
		},
		toInternalWorkbench(){
			this.$router.push("/internal/workbench")
		},
		toOfficialWebsite(){
			window.location.href = 'https://www.iotmax.com.cn/'
		},
		toWarehouseManage(){
			this.$router.push("/warehouse")
		},
		toProductList(){
			this.$router.push("/warehouse/product")
		},
		toProductDetail(item){
			this.$router.push({ path: '/warehouse/detail', query: { type: 'product', id: item.id } })
		},
		toMaterialList(){
			this.$router.push("/warehouse/material")
		},
		toMaterialDetail(item){
			this.$router.push({ path: '/warehouse/detail', query: { type: 'material', id: item.id } })
		},
		toShipmentRecord(){
			this.$router.push("/warehouse/shipment")
		},
		toShipmentDetail(item){
			this.$router.push({ path: '/warehouse/shipment/detail', query: { id: item.id } })
		},

		openShipment(type, item) {
			this.shipmentType = type || 'product'
			if (item) {
				this.preselectedShipmentItems = [{
					id: item.id,
					name: item.name,
					code: item.code,
					stock_num: item.stock_num || 0,
					stock_num_info: item.stock_num_info || []
				}]
			} else {
				this.preselectedShipmentItems = []
			}
			this.showShipmentDialog = true
		},

		onShipmentSuccess() {
			// 刷新预览数据
			this.fetchPreviewData()
		}
	}
}
</script>

<style scoped>
	.mine{
		width: 100%;
		height: 100vh;
		background: #F6F6F6;
		overflow-y: auto;
		padding-bottom: 130px;
		box-sizing: border-box;
	}
	.mine_head{
		width: 100%;
		height: 200px;
		background: url('/static/imgs/user_head.png');
		background-size:100% 100%; 
	}
	.min_user{
		width: calc(100% - 60px);
		margin-left: 30px;
		margin-top: -60px;
		height: 257px;
		position: relative;
		z-index: 9;
		background: #FFFFFF;
		border-radius: 20px 20px 20px 20px;
		display: inline-block;
	}
	.mine_img{
		position: absolute;
		width: 210px;
		height: 210px;
		background: #FFFFFF;
		border-radius: 50%;
		top: -105px;
		left: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.mine_img img{
		width: 200px;
		height: 200px;
		border-radius: 50%;
	}
	.min_user_name{
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-size: 32px;
		color: #333333;
		font-weight: bold;
		padding-left: 48px;
		margin-top: 124px;
		box-sizing: border-box;
	}
	.mun_bottonm{
		width: 100%;
		padding: 0 0.64rem;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 16px;
	}
	.mb_left{
		font-size: 28px;
		color: #999999;
		line-height: 40px;
	}
	.mb_right{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-size: 28px;
		color: #4E89FF;
	}
	.mb_right .van-icon{
		margin-right: 16px;
	}
	.min_add{
		width: calc(100% - 60px);
		margin-left: 30px;
		padding: 0 30px;
		box-sizing: border-box;
		height: 120px;
		background: #FFFFFF;
		border-radius: 20px 20px 20px 20px;
		opacity: 1;
		margin-top: 24px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.minadd_left{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-size: 28px;
		color: #333333;
		font-weight: bold;
		margin-left: 16px;
	}
	.ml_icon .van-icon{
		margin-right: 10px;
	}
	.minadd_right{
		width: 45px;
		height: 45px;
		background: #E2ECFF;
		opacity: 1;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.about_us{
		width: calc(100% - 60px);
		height: 120px;
		margin: 24px 0 0 30px;
		padding: 0 30px 0 46px;
		border: 0;
		border-radius: 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #333333;
		font-size: 28px;
		font-weight: bold;
		font-family: inherit;
		text-align: left;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;
	}
	.about_us:active{
		background: #F7F9FF;
		transform: scale(.99);
	}
	.about_left{
		display: flex;
		align-items: center;
	}
	.about_icon{
		display: flex;
		align-items: center;
		margin-right: 10px;
	}
	.about_arrow{
		width: 45px;
		height: 45px;
		border-radius: 50%;
		background: #E2ECFF;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.warehouse_dashboard{
		width: calc(100% - 60px);
		margin: 24px 0 0 30px;
		padding: 24px;
		box-sizing: border-box;
		background: linear-gradient(135deg, #1E88E5 0%, #4E89FF 100%);
		border-radius: 20px;
		color: #fff;
	}
	.dashboard_top{
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 12px;
	}
	.dashboard_title{
		font-size: 30px;
		font-weight: bold;
		line-height: 1.2;
	}
	.dashboard_subtitle{
		font-size: 22px;
		opacity: 0.85;
		margin-top: 6px;
	}
	.dashboard_manage{
		display: flex;
		align-items: center;
		gap: 4px;
		font-size: 22px;
		opacity: 0.9;
		padding: 6px 10px;
		border-radius: 14px;
		background: rgba(255,255,255,0.16);
	}
	.dashboard_stats{
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 12px;
		margin-top: 20px;
	}
	.dashboard_stat{
		background: rgba(255,255,255,0.14);
		border-radius: 14px;
		padding: 14px 10px;
		text-align: center;
	}
	.stat_num{
		display: block;
		font-size: 34px;
		font-weight: bold;
		line-height: 1;
	}
	.stat_num.green{
		color: #B9F6CA;
	}
	.stat_num.red{
		color: #FFCDD2;
	}
	.stat_label{
		display: block;
		font-size: 22px;
		margin-top: 6px;
		opacity: 0.92;
	}
	.dashboard_actions{
		display: flex;
		gap: 12px;
		margin-top: 18px;
	}
	.dashboard_action{
		flex: 1;
		height: 72px;
		border-radius: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		font-size: 24px;
		font-weight: bold;
	}
	.dashboard_action.primary{
		background: rgba(255,255,255,0.18);
	}
	.dashboard_action.success{
		background: rgba(255,255,255,0.12);
	}
	.minadd_right .van-icon{
		font-size: 20px;
	}

	/* 预览区域样式 */
	.preview_section{
		width: calc(100% - 60px);
		margin-left: 30px;
		margin-top: 24px;
		background: #FFFFFF;
		border-radius: 20px;
		padding: 24px;
		box-sizing: border-box;
		position: relative;
		overflow: visible;
	}
	.section_header{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;
	}
	.section_title_left{
		display: flex;
		align-items: center;
	}
	.section_title_text{
		font-size: 30px;
		font-weight: bold;
		color: #333;
		margin-left: 10px;
	}
	.section_more{
		display: flex;
		align-items: center;
		font-size: 24px;
		color: #999;
	}
	.section_more span{
		margin-right: 4px;
	}

	/* 产品/物料预览卡片 */
	.preview_cards{
		display: flex;
		flex-direction: column;
		gap: 16px;
	}
	.preview_card{
		display: flex;
		align-items: flex-start;
		padding: 16px;
		background: #F8F9FA;
		border-radius: 12px;
	}
	.pc_img{
		width: 100px;
		height: 100px;
		border-radius: 10px;
		overflow: hidden;
		flex-shrink: 0;
		background: #eee;
	}
	.pc_img img{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.pc_info{
		flex: 1;
		margin-left: 16px;
		min-width: 0;
	}
	.pc_name{
		font-size: 28px;
		font-weight: bold;
		color: #333;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.pc_code{
		font-size: 22px;
		color: #999;
		margin-top: 4px;
	}
	.pc_stock{
		margin-top: 8px;
		background: rgba(78, 137, 255, 0.06);
		padding: 6px 14px;
		border-radius: 6px;
		display: inline-block;
	}
	.stock_total{
		font-size: 22px;
		color: #666;
	}
	.stock_total b{
		font-size: 32px;
		color: #4E89FF;
		font-weight: bold;
	}
	.stock_total b.low{
		color: #F44336;
	}
	.pc_warehouse{
		margin-top: 8px;
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}
	.wh_tag{
		font-size: 22px;
		color: #666;
		background: #f0f5ff;
		border: 1px solid rgba(78, 137, 255, 0.15);
		padding: 2px 12px;
		border-radius: 6px;
	}
	.wh_tag b{
		font-weight: bold;
		margin-left: 4px;
	}

	/* 发货预览列表 */
	.mine_wh_row{
		display: flex;
		gap: 12px;
		padding: 0 16px 12px;
		overflow-x: auto;
	}
	.mine_wh_btn{
		white-space: nowrap;
		padding: 6px 18px;
		border-radius: 20px;
		font-size: 24px;
		color: #666;
		background: #f5f5f5;
		cursor: pointer;
		transition: all .2s;
	}
	.mine_wh_btn.active{
		color: #fff;
		background: linear-gradient(135deg, #4E89FF, #6C63FF);
		font-weight: bold;
	}

	.shipment_preview_list{
		display: flex;
		flex-direction: column;
		gap: 16px;
	}
	.shipment_preview_item{
		padding: 16px;
		background: #F8F9FA;
		border-radius: 12px;
	}
	.sp_header{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 10px;
	}
	.sp_time{
		font-size: 22px;
		color: #999;
	}
	.sp_body{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.sp_name{
		font-size: 28px;
		color: #333;
		font-weight: bold;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		max-width: 70%;
	}
	.sp_num{
		font-size: 26px;
		color: #666;
	}
	.sp_footer{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 10px;
	}
	.sp_sale{
		font-size: 22px;
		color: #999;
	}
	.sp_status{
		font-size: 22px;
		padding: 2px 12px;
		border-radius: 6px;
		background: #eee;
		color: #999;
	}
	.sp_status.step5{
		background: #E8F5E9;
		color: #4CAF50;
	}

	/* 空状态 */
	.preview_empty{
		text-align: center;
		padding: 30px 0;
		color: #ccc;
		font-size: 26px;
	}

	/* 悬浮发货按钮 - 浮在栏目卡片区右下角 */
	.section_float_btn{
		position: absolute;
		bottom: 16px;
		right: 16px;
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 10px 20px;
		border-radius: 30px;
		color: #fff;
		font-size: 24px;
		font-weight: bold;
		cursor: pointer;
		z-index: 10;
	}
	.section_float_btn.product_float{
		background: linear-gradient(135deg, #F44336, #D32F2F);
		box-shadow: 0 4px 12px rgba(244,67,54,0.35);
	}
	.section_float_btn.material_float{
		background: linear-gradient(135deg, #4CAF50, #388E3C);
		box-shadow: 0 4px 12px rgba(76,175,80,0.35);
	}
	.section_float_btn:active{
		transform: scale(0.92);
		opacity: 0.85;
	}
</style>
